import { supabase } from '../../shared/supabase/supabaseClient';
import type { OptimizedProductImages } from './optimizeProductImage';
import {
  catalogImageContentType,
  catalogImageFileExt,
  catalogVariantStoragePath,
} from './catalogImageStorage';
import { decodeBase64, getPublicUrl, uploadToStorageWithRetry } from './storageUploadRetry';

const PRODUCT_IMAGES_BUCKET = 'product-images';

export async function uploadCategoryImage(params: {
  orgId: string;
  categoryId: string;
  optimized: OptimizedProductImages;
}): Promise<string> {
  const { orgId, categoryId, optimized } = params;

  const ext = catalogImageFileExt(optimized);
  const contentType = catalogImageContentType(ext);
  const variants = [
    { suffix: 'thumb' as const, base64: optimized.thumb.base64 },
    { suffix: 'medium' as const, base64: optimized.medium.base64 },
    { suffix: 'full' as const, base64: optimized.full.base64 },
  ];

  for (const variant of variants) {
    const storagePath = catalogVariantStoragePath(orgId, categoryId, variant.suffix, ext);
    try {
      await uploadToStorageWithRetry({
        bucket: PRODUCT_IMAGES_BUCKET,
        path: storagePath,
        body: decodeBase64(variant.base64),
        contentType,
      });
    } catch (err) {
      throw new Error(`No se pudo subir la imagen (${variant.suffix}): ${(err as Error).message}`);
    }
  }

  return getPublicUrl(PRODUCT_IMAGES_BUCKET, catalogVariantStoragePath(orgId, categoryId, 'full', ext));
}

export async function removeCategoryImage(params: {
  orgId: string;
  categoryId: string;
}): Promise<void> {
  const { orgId, categoryId } = params;

  const pathsToRemove = [
    `${orgId}/${categoryId}-thumb.webp`,
    `${orgId}/${categoryId}-medium.webp`,
    `${orgId}/${categoryId}-full.webp`,
    `${orgId}/${categoryId}-thumb.jpg`,
    `${orgId}/${categoryId}-medium.jpg`,
    `${orgId}/${categoryId}-full.jpg`,
  ];

  try {
    await supabase.storage.from('product-images').remove(pathsToRemove);
  } catch (err) {
    console.warn('[categoryImageRepo] No se pudo borrar las imágenes del bucket', err);
  }
}
